import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const CartMessageContext = createContext(null);

export function CartMessageProvider({ children }) {
  const [toast, setToast] = useState({
    open: false,
    text: '',
    variant: 'success',
  });

  const hideCartMessage = useCallback(() => {
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  const showCartMessage = useCallback((text, variant = 'success') => {
    if (!text) return;
    setToast({ open: true, text, variant });
  }, []);

  const value = useMemo(() => ({ showCartMessage }), [showCartMessage]);

  return (
    <CartMessageContext.Provider value={value}>
      {children}
      <Snackbar
        open={toast.open}
        autoHideDuration={2800}
        onClose={hideCartMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{
          bottom: { xs: 88, md: 28 },
          left: { xs: 16, sm: 'auto' },
          right: { xs: 16, sm: 'auto' },
          maxWidth: 420,
          mx: 'auto',
        }}
      >
        <Alert
          severity={toast.variant}
          variant="filled"
          sx={{
            width: '100%',
            fontWeight: 700,
            boxShadow: '0 8px 28px rgba(0,0,0,0.18)',
            alignItems: 'center',
          }}
        >
          {toast.text}
        </Alert>
      </Snackbar>
    </CartMessageContext.Provider>
  );
}

export function useCartMessage() {
  const context = useContext(CartMessageContext);
  if (!context) {
    throw new Error('useCartMessage must be used within CartMessageProvider');
  }
  return context;
}
